const MAX_FILE_NAME_LENGTH = 64;
const ELLIPSIS = '…';
const EXTENSION_PATTERN = /\.[^.\s]{1,10}$/;

export interface ShortenedFileName {
    beginning: string;
    ending: string;
}

export function shortenFileName(fileName: string): ShortenedFileName {
    const extension = fileName.match(EXTENSION_PATTERN)?.[0] ?? '';

    if (fileName.length <= MAX_FILE_NAME_LENGTH) {
        return { beginning: fileName.slice(0, fileName.length - extension.length), ending: extension };
    }

    return {
        beginning: fileName.slice(0, MAX_FILE_NAME_LENGTH - ELLIPSIS.length - extension.length),
        ending: `${ELLIPSIS}${extension}`,
    };
}
